import {
  FETCH_REQUEST_FAILURE,
  FETCH_REQUEST_LOADING,
  FETCH_REQUEST_SUCCESS,
  DELETE_REQUEST_LOADING,
  DELETE_REQUEST_SUCCESS,
  DELETE_REQUEST_FAILURE
} from '../Types/requestTypes';
import api from '../config/api';

const API_WP = process.env.REACT_APP_API_URL;

export const getRequests = (start, end, page, limit, searchKeyword, filters) => {
  return dispatch => {
    dispatch({ type: FETCH_REQUEST_LOADING });
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(searchKeyword && { search: searchKeyword }),
      ...(filters.userId && { userId: filters.userId }),
      ...(filters.validatorId && { validatorId: filters.validatorId }),
      ...(filters.status && { status: filters.status }),
      ...(filters.type && { type: filters.type })
    }).toString();
    api
      .get(`${API_WP}Request/getRequests/${start}/${end}?${queryParams}`)
      .then(response => {
        const { data, pagination } = response.data;
        dispatch({
          type: FETCH_REQUEST_SUCCESS,
          payload: { data, pagination }
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_REQUEST_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const fetchRequestsWithoutDispatch = async (
  start,
  end,
  page,
  limit,
  searchKeyword,
  filters
) => {
  const queryParams = new URLSearchParams({
    ...(searchKeyword && { search: searchKeyword }),
    ...(filters.userId && { userId: filters.userId }),
    ...(filters.validatorId && { validatorId: filters.validatorId }),
    ...(filters.status && { status: filters.status }),
    ...(filters.type && { type: filters.type })
  }).toString();
  try {
    const response = await api.get(`${API_WP}Request/getRequests/${start}/${end}?${queryParams}`);
    return response.data.data;
  } catch (e) {
    return e;
  }
};

export const deleteRequest = id => {
  return dispatch => {
    dispatch({ type: DELETE_REQUEST_LOADING });
    return api
      .delete(`${API_WP}Request/cancelRequest/${id}`)
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: DELETE_REQUEST_SUCCESS,
            payload: id
          });
        } else {
          dispatch({
            type: DELETE_REQUEST_FAILURE,
            payload: response.data.message
          });
        }
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: DELETE_REQUEST_FAILURE,
          payload: errorMsg
        });
      });
  };
};
